export default __webpack_public_path__ + "static/media/complete.7c70b6ae.png";